import { Text } from '@capsicum/common-web';
import styled from 'styled-components';

export type ListedTextProps = {
	note?: string;
	points: Array<{ subPoints?: Array<string>; text: string } | string>;
	useNumericList?: boolean;
};

export const ListedText = ({ note, points, useNumericList }: ListedTextProps) => {
	return (
		<>
			<S.List>
				{points.map((point, index) => {
					const isComplexPoint = typeof point === 'object' && point.text;
					const mainText = (isComplexPoint ? point.text : point) as string;
					const subPoints = isComplexPoint ? point.subPoints : undefined;

					return (
						<div key={index}>
							<Text variant="text3">
								{useNumericList ? `${index + 1}. ` : '• '}
								{mainText}
							</Text>
							{subPoints && (
								<S.List>
									{subPoints.map((subPoint, subIndex) => (
										<Text key={subIndex} variant="text3">
											{useNumericList ? `${subIndex + 1}. ` : '• '}
											{subPoint}
										</Text>
									))}
								</S.List>
							)}
						</div>
					);
				})}
			</S.List>
			{note && (
				<S.ListNote>
					<Text variant="text3">{note}</Text>
				</S.ListNote>
			)}
		</>
	);
};

namespace S {
	export const List = styled.div`
		margin: 0;
		padding: 0;
		padding-left: ${({ theme }) => theme.spacings.small};
	`;

	export const ListNote = styled.div`
		margin-top: ${({ theme }) => theme.spacings.medium};
		white-space: pre-wrap;
	`;
}
